import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";

type TemplateStatus = "queued" | "extracting" | "done" | "error" | "pending_review" | "reviewed";

interface TemplateTabStripProps {
  templates: Array<{ id: string; name: string }>;
  selectedId: string;
  onSelect: (id: string) => void;
  statuses?: Record<string, TemplateStatus>;
  disabledIds?: string[];
}

const TemplateTabStrip = ({ templates, selectedId, onSelect, statuses, disabledIds }: TemplateTabStripProps) => {
  if (templates.length <= 1) return null;
  return (
    <Tabs value={selectedId} onValueChange={onSelect}>
      <TabsList variant="line" className="flex-wrap">
        {templates.map(t => {
          const s = statuses?.[t.id];
          return (
            <TabsTrigger key={t.id} value={t.id} disabled={disabledIds?.includes(t.id)}>
              {t.name}
              {s === "queued"     && <span className="ml-1.5 inline-block w-2 h-2 rounded-full bg-yellow-400" />}
              {s === "extracting" && <Loader2 className="ml-1.5 w-3 h-3 animate-spin" />}
              {s === "done"       && <span className="ml-1.5 inline-block w-2 h-2 rounded-full bg-blue-600" />}
              {s === "error"        && <span className="ml-1.5 inline-block w-2 h-2 rounded-full bg-red-500" />}
              {s === "pending_review" && <span className="ml-1.5 inline-block w-2 h-2 rounded-full bg-yellow-400" />}
              {s === "reviewed"    && <span className="ml-1.5 inline-block w-2 h-2 rounded-full bg-green-500" />}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
};

export default TemplateTabStrip;
